export const getSlugValue = label => {
  return label.toLowerCase().replace(' ', '-');
}